import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../../../config/apiConfig';
import './css/AnalyticsCaseHistory.css';

export const AnalyticsCaseHistory = ({ onViewCase }) => {
  const [expanded, setExpanded] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const authToken = localStorage.getItem("authToken");

  const togglePanel = () => {
    setExpanded(!expanded);
  };

  const fetchOptimizations = () => {
    setLoading(true);
    axios
      .get(API_ENDPOINTS.getAllOptimizations, {
        headers: {
          Authorization: `Token ${authToken}`,
        },
      })
      .then((response) => {
        if (Array.isArray(response.data)) {
          const sortedData = response.data.sort(
            (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
          );
          setTableData(sortedData);
        } else {
          console.error("Unexpected response format:", response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchOptimizations();
  }, [authToken]);

  const handleViewCase = (caseId) => {
    setLoading(true);
    axios
      .get(API_ENDPOINTS.getOptimization, {
        headers: {
          Authorization: `Token ${authToken}`,
        },
        params: {
          case_id: caseId,
        },
      })
      .then((response) => {
        if (response.data && typeof response.data === 'object') {
          onViewCase(response.data);
        } else {
          console.error('Invalid response data format:', response.data);
          alert('Error: Received invalid data format from server');
        }
      })
      .catch((error) => {
        console.log('Case ID that failed:', caseId);
        console.error('Error fetching optimization case:', error.message);
        if (error.response) {
          console.error('Error response data:', error.response.data);
          console.error('Error response status:', error.response.status);
          console.error('Error response headers:', error.response.headers);
        } else if (error.request) {
          console.error('No response received:', error.request);
        } else {
          console.error('Error config:', error.config);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDeleteCase = (caseId, caseName) => {
    if (window.confirm(`Are you sure you want to delete the case "${caseName}"? This action cannot be undone.`)) {
      setLoading(true);
      axios
        .delete(API_ENDPOINTS.deleteOptimization, {
          headers: {
            Authorization: `Token ${authToken}`,
          },
          params: {
            case_id: caseId,
          },
        })
        .then((response) => {
          // Remove the deleted case from the table data
          setTableData(tableData.filter(item => item.id !== caseId));
          alert('Case deleted successfully');
        })
        .catch((error) => {
          console.error('Error deleting case:', error);
          alert('Failed to delete case. Please try again.');
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  // Define columns with widths
  const columns = [
    { key: 'checkbox', label: '', width: '5%' },
    { key: 'name', label: 'Name', width: '35%' },
    { key: 'timestamp', label: 'Timestamp', width: '35%' },
    { key: 'action', label: 'Action', width: '25%' }
  ];
  
  return (
    <div className="dashboard-container run-history">
      <div className="parameter-panel">
        <div
          className="panel-header"
          onClick={togglePanel}
        >
          <h3>Click to Unfold</h3>
          <span className={`panel-toggle ${expanded ? 'expanded' : ''}`}>
            {expanded ? '−' : '+'}
          </span>
        </div>

        <div className={`panel-content ${expanded ? 'expanded' : ''}`}>
          <div className="history-table-container">
            {loading && !tableData.length ? (
              <p>Loading Table...</p>
            ) : (
              <table className="table">
                <thead>
                  <tr className="table-header">
                    <th style={{ width: columns[0].width }}></th>
                    <th style={{ width: columns[1].width }}>Name</th>
                    <th style={{ width: columns[2].width }}>Timestamp</th>
                    <th style={{ width: columns[3].width }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((optimization, index) => (
                    <tr key={`${optimization.case_name}-${index}`}>
                      <td style={{ width: columns[0].width }}>
                        <input type="checkbox" className="charger-checkbox" />
                      </td>
                      <td style={{ width: columns[1].width }}>{optimization.case_name}</td>
                      <td style={{ width: columns[2].width }}>{new Date(optimization.timestamp).toLocaleString()}</td>
                      <td style={{ width: columns[3].width }}>
                        <button 
                          className="view-button"
                          onClick={() => handleViewCase(optimization.id)}
                        >
                          View
                        </button>
                        <button 
                          className="delete-button"
                          onClick={() => handleDeleteCase(optimization.id, optimization.case_name)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {loading && (
              <div className="loading-overlay">
                <div className="loading-spinner"></div>
                <p className="loading-text">Loading Case History...</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}; 